import { FileButton, DataGrid, Icon, TableLayout } from '@/components'
import { BaseGridProps, ColumnDef } from '@/components/app/DataGrid/types'
import { USER_TYPE_ADMIN, USER_TYPE_ADVISOR, USER_TYPE_ARRANGER } from '@/constants/prop/UserType'
import { useDownFileGet } from '@/hooks'
import { PropertyDocumentFile } from '@/model/types/PropertyItem'
import useStore from '@/store'
import { useNavigate } from 'react-router-dom'

function FileGrid( props: FileGridProps ) {
    const {
        data, isNonDisplayTelNo = false, isUploadAuth = true,
        onAddFile, setData,
    } = props
    const downFile = useDownFileGet()
    const navigator = useNavigate()
    const { isLogin } = useStore()

    const onCustomClickFileButton = ( files: FileList ): void => {
        const uuid = Math.random()
        const fileDatas: PropertyDocumentFile[] = Array.from( files ).map( ( file ) => ( {
            file, fileName: file.name, uuid,
        } ) )
        setData( [ ...data, ...fileDatas ] )
        onAddFile && onAddFile( [ ...data, ...fileDatas ] )
    }

    const onDeleteFile = async ( row: BaseGridProps<PropertyDocumentFile> ): Promise<void> => {
        const { fileId: rowFileId, uuid: rowUuid } = row
        const rowData: BaseGridProps<PropertyDocumentFile>[] = [ ...data ]

        if ( !rowFileId ) {
            setData( rowData.filter( ( { uuid } ) => uuid !== rowUuid ) )
            return
        }
        const result = confirm( '파일을 삭제하시겠습니까?' )
        if ( result ) {
            setData( data.filter( ( { fileId } ) => fileId !== rowFileId ) )
        }
    }

    const onDownFile = ( row: Record<string, any> ): void => {
        const { file, fileId, fileName } = row

        !fileId ? downFileURL( file, fileName ) : downFile( fileId )
    }

    const downFileURL = ( file, fileName ) => {
        const url = window.URL.createObjectURL( file )
        const link = document.createElement( 'a' )
        link.href = url
        link.download = decodeURIComponent( fileName )
        link.click()
        window.URL.revokeObjectURL( link.toString() )
    }

    const columnDefs: ColumnDef[] = [
        {
            field: 'fileName', headerName: '파일명', width: isNonDisplayTelNo ? '90%' : '60%', editable: false, textAlign: 'center'
        },
        !isNonDisplayTelNo && {
            field: 'telNo', headerName: '전화번호', width: '30%', textAlign: 'center'
        },
        {
            field: 'downButton',
            width: 50,
            type: 'button',
            buttonProps: {
                icon: 'download',
                variant: 'contained',
                onClick: ( row ) => {
                    if( isLogin ) {
                        onDownFile( row )
                    } else {
                        const result = confirm( '로그인 하셔야 첨부파일 다운이 가능 합니다.\n이동 하시겠습니까?' )
                        if( result ) navigator( '/login', { state: { isSimple: true } } )
                    }
                },
            }
        },
        isUploadAuth && {
            field: 'deleteButton',
            width: 50,
            type: 'button',
            buttonProps: {
                icon: 'delete',
                color: 'error',
                variant: 'contained',
                onClick: ( documentFile: PropertyDocumentFile ) => {
                    if( isLogin ) {
                        onDeleteFile( documentFile )
                    } else {
                        const result = confirm( '로그인 하셔야 첨부파일 삭제 가능 합니다.\n이동 하시겠습니까?' )
                        if( result ) navigator( '/login' )
                    }
                },
            }
        },
    ]

    return (
        <>
            <TableLayout.Grid
                actions={
                    <>
                        { isUploadAuth &&
                            <FileButton
                                className="button-grid"
                                onClick={ onCustomClickFileButton }
                            >
                                <Icon>add</Icon>
                            </FileButton>
                        }
                    </>
                }
                grid={
                    <DataGrid<PropertyDocumentFile>
                        columnDefs={ columnDefs }
                        rowData={ data }
                        setRowData={ setData }
                    />
                }
            />
        </>
    )
}

export default FileGrid

export interface FileGridProps {
    data: PropertyDocumentFile[]
    isNonDisplayTelNo?: boolean
    isUploadAuth?: boolean
    isNoDeleteAuth?: boolean
    setData: ( fileData: PropertyDocumentFile[] ) => void
    onAddFile?: ( fileData: PropertyDocumentFile[] ) => void
}

const buttonAuth = [
    USER_TYPE_ADMIN.value,
    USER_TYPE_ADVISOR.value,
    USER_TYPE_ARRANGER.value
]